import React from 'react';

function Widget({ title, children, className = "", titleAction = null }) {
  return (
    <div className={`bg-[#1e1e1e] rounded-lg shadow-lg overflow-hidden ${className}`}>
      {title && (
        <div className="px-4 py-3 border-b border-[#2a2a2a] flex items-center justify-between">
          <h3 className="text-lg font-medium text-white">{title}</h3>
          {titleAction}
        </div>
      )}
      <div className="p-4">{children}</div>
    </div>
  );
}

export default Widget;

